import React, { useState, useEffect, useRef } from "react";
import "./GroupeCreation.scss";
import PropTypes from "prop-types";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FaCog } from "react-icons/fa";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import axios from "axios";
import { isNotEmptyArray } from "Services/functions";
import { Controller, useForm } from "react-hook-form";
import Loader from "Components/Loader/loader";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import ChargementImage from "Components/ChargementImage/ChargementImage";
import { updateGroups } from "Redux/Actions/groupsActions";
import { Calendar } from "primereact/calendar";
import BtnBlanc from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import Modal from "Components/Modal/Modal";
import ModalCharteGroupes from "Components/Modal/ModalCharteGroupes/ModalCharteGroupes";
import ReactQuill from "react-quill";
import QuillOptions from "Components/QuillOptions/QuillOptions";
import { DateTime } from "luxon";
import DOMPurify from "dompurify";
import SearchPeople from "Components/SearchPeople/SearchPeople";
import { CgClose } from "react-icons/cg";
import { fetchGet, useFetchGetPagination } from "Services/api";
/**
 * Permet d'afficher le formulaire de création de groupe
 */
// TO DO : envoyer les utilisateurs de membres à l'api au moment de la soumission
const GroupeCreation = (props) => {
  const [visibleModalCharte, setvisibleModalCharte] = useState(false);
  // ------- VARIABLES DES GROUPES
  // Contiendra les données du formulaire après soumission de celui-ci
  const [formData, setFormData] = useState("");
  // composante de formation associée au groupe
  const composanteData = props.secondaryTables.educationComposanteData;
  // domaine de formation associé au groupe
  const formationData = props.secondaryTables.domainsData;
  // spécialité de formation associée au groupe
  const specialiteData = props.groups.specialitesFormation;
  const [members, setMembers] = useState([]);

  const [submitted, setSubmitted] = useState(false);

  const updateState = async () => {};

  useEffect(() => {
    if (props.states.statesData && props.states.statesData.length > 0) {
      if (props.auth.isAdmin) {
        props.handleGroups({
          group_status_envoi: props.states.statesData.filter(
            (status) => status.statusLabel == "Publié"
          )[0],
        });
      } else {
        props.handleGroups({
          group_status_envoi: props.states.statesData.filter(
            (status) => status.statusLabel == "En attente"
          )[0],
        });
      }
    }
  }, [props.states.statesData]);

  // Constantes comprenant les données par défaut du formulaire de création d'une actu
  const defaultValues = {
    label: "",
    description: "",
    public: false,
    institutional: false,
    groupStatus: null,
    graduationYear: null,
    groupCategory: null,
    educationDomain: null,
    educationComposante: null,
    educationSpeciality: null,
    createdBy: true,
    image: "",
  };

  // ------- VARIABLES GESTION IMAGES ----------
  // La photo vient-elle de la photothèque ?
  const [phototheque, setPhototheque] = useState(true);
  // Contiendra l'url de l'image choisie (upload ou photothèque)
  const [imageFile, setImageFile] = useState("");
  // ID de l'image choisie (phototheque)
  const [imageId, setImageId] = useState("");

  // Contiendra le fichier upload par l'utilisateur
  const [image, setImage] = useState("");

  // ------- VARIABLES GESTION FORMULAIRE ----------
  // catégorie de l'actu choisie
  const [categories, setCategories] = useState([]);
  // Défini si l'actualité a bien été publiée / soumise ou non
  // const [isSubmitted, setSubmitted] = useState(false);

  // ------- TOASTS ----------
  // Toast de succès d'upload d'image
  const uploadToast = useRef(null);
  // Toast de suppression de l'image upload
  const cancelToast = useRef(null);

  // ------- GESTION AJOUT MEMBRES ----------
  const [filteredMembersURL, setFilteredMembersURL] = useState(null);
  const filteredMembersQuery = useFetchGetPagination(
    filteredMembersURL,
    props.auth.token
  );
  const [filteredMembers, setFilteredMembers] = useState([]);

  useEffect(() => {
    // On enlève l'utilisateur connecté de la liste des membres
    let newFilteredMembers = filteredMembers.filter(
      (member) => member.id != props.auth.userConnected.id
    );
    if (members.length === 0) setMembers([...newFilteredMembers]);
  }, [filteredMembers]);

  useEffect(() => {
    if (filteredMembersQuery.loaded && filteredMembersQuery.data) {
      setFilteredMembers(filteredMembersQuery.data);
    }
  }, [filteredMembersQuery]);

  // Une fois les catégories chargées, on les stocke dans un tableau :
  useEffect(async () => {
    /// Récupérer les catégories, et les filtrer par ordre alphabétique
    const categoriesList = isNotEmptyArray(props.groups.categories)
      ? props.groups.categories
      : await fetchGet("/group_categories", props.auth.token);
    setCategories([]);
    let tempArray = [];
    categoriesList.forEach((category) => tempArray.push(category));
    tempArray = tempArray.sort((a, b) => a.label.localeCompare(b.label));
    setCategories(tempArray);
  }, [props.groups.categories]);

  const [specialites, setSpecialites] = useState(null);

  useEffect(() => {
    if (!specialiteData) return;

    let tempArray = [];
    specialiteData.forEach((specialite) => {
      let diplomes = specialite?.diplomes;
      tempArray.push({
        ...specialite,
        customLabel: `${specialite?.label}${
          isNotEmptyArray(diplomes) ? " (" + diplomes[0]?.codeDiplome + ")" : ""
        }`,
      });
    });
    tempArray = tempArray.sort((a, b) => a?.label?.localeCompare(b?.label));
    setSpecialites(tempArray);
  }, [specialiteData]);

  // Une fois le formulaire soumis, on lance le processus d'envoi de données
  useEffect(() => {
    if (formData !== "") {
      if (props.auth.userConnected.charteGroupSigned) {
        postForm();
      } else {
        setvisibleModalCharte(true);
      }
    }
  }, [formData]);

  /**
   * Fonction permettant de convertir les données du formulaire
   * en format {@link FormData} et des les envoyer au serveur
   * @param {Object} data données du formulaire
   */
  const sendRequest = (data) => {
    // Variable qui stockera la réponse du serveur
    // let response = null;
    // On crée un FormData qui sera envoyé au serveur
    var dataForm = new FormData();
    // On ajoute les données du formulaire au formData
    for (var key in data) dataForm.append(key, data[key]);

    // On envoie le formData au serveur
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}${"/groups/request/validation"}`,
        dataForm,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                "Content-Type": "multipart/form-data",

                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
        }
      )
      .then(() => {
        reset();
        setImage(null);
        setImageFile(null);
        setPhototheque(true);
        setSubmitted(true);
      })
      .catch((error) => {
        if (error.response) {
          if (
            error.response?.statusText === "Unprocessable Entity" ||
            error.response?.status == 422
          )
            cancelToast.current.show({
              severity: "error",
              summary: "Erreur : ",
              detail:
                error?.response?.data?.detail ||
                "L'image doit être au format paysage et ne doit pas dépasser 1Mo",
              life: 10000,
            });
          else
            cancelToast.current.show({
              severity: "error",
              summary: "Erreur : ",
              detail:
                error?.response?.data?.detail || "Une erreur est survenue.",
              life: 10000,
            });
        } else
          cancelToast.current.show({
            severity: "error",
            summary: "Erreur : ",
            detail: "Une erreur est survenue.",
            life: 10000,
          });
      });
    // Si tout s'est bien passé, on reset le formulaire
    // .finally(() => {
    //   if (response) {
    //     reset();
    //     // setUrlActu([""]);
    //     // setPublic(true);
    //     // setAuteurActu(false);
    //     // setSubmitted(true);
    //     setImage(null);
    //     setImageFile(null);
    //     setPhototheque(true);
    //     setSubmitted(true);
    //   }
    // });
  };

  const sendMembers = (data) => {
    if (data) return data;
    // Si groupe institutionnel, on ajoute les membres en tant que statut "ACTIF"
    // Sinon on ajoute les membres en tant que statut "INVITE"
  };

  /**
   * Remplissage de la key image selon différentes conditions
   * @param {Object} data données pour la requêtes
   * @returns {Object}
   */
  const fillImage = (data) => {
    // Si une image a été téléchargée, on met son url local dans la key imageFile
    if (imageFile && !phototheque) {
      data.imageFile = imageFile;
      delete data.imageStockId;
    }
    // Sinon, on met l'url de l'image choisie de la photothèque
    else if (phototheque) {
      data.imageStockId = imageId;
      delete data.imageFile;
      delete data.image;
    }
    return data;
  };

  /**
   * Remplissage de la key category selon différentes conditions
   * @param {Object} data données pour la requêtes
   * @returns {Object}
   */
  const fillCategory = (data) => {
    // Si catégory est vide on met la catégorie par défaut 'Autre'
    if (!data.groupCategory) data.groupCategory = "Autre";

    // Si la key id existe, pas de besoin de chercher l'id de la catégorie
    if (data.groupCategory.id)
      data.groupCategory = "/api/group_categories/" + data.groupCategory.id;
    /* 
    Sinon, on cherche si la catégorie existe déjà :
    // Si oui : on met l'id de la catégorie
     Si non : on spécifie qu'elle doit être créée
     */ else {
      const category = categories.find(
        (category) => category.label === data.groupCategory
      );
      if (category) data.groupCategory = "/api/group_categories/" + category.id;
      else data.groupCategory = JSON.stringify({ label: data.groupCategory });
    }
    return data;
  };

  /**
   * Remplissage des keys educationComposante, graduationYear, domain et educationSpeciality
   * selon différentes conditions
   * @param {Object} data données pour la requêtes
   * @returns {Object} - données pour la requêtes
   */
  const fillAssociations = (data) => {
    // Si le champ spécialité est renseigné, on met l'id de la spécialité
    if (data.educationSpeciality && data.educationSpeciality.id)
      data.educationSpeciality =
        "/api/education_specialities/" + data.educationSpeciality.id;
    // Si le champ domaine est renseigné, on met l'id du domaine
    if (data.educationDomain && data.educationDomain.id)
      data.educationDomain = "/api/domains/" + data.educationDomain.id;
    // Si le champ composante est renseigné, on met l'id de la composante
    if (data.educationComposante && data.educationComposante.id)
      data.educationComposante =
        "/api/education_composantes/" + data.educationComposante.id;
    // Si le champ année de graduation est renseigné, on met l'année au lieu d'un jsDate
    if (data.graduationYear)
      data.graduationYear = DateTime.fromJSDate(data.graduationYear).year;
    return data;
  };

  const cleanEmptyKeys = (data) => {
    // Suppression des keys qui ne sont pas remplies sauf les clés à false
    for (var key in data)
      if (data[key] === "" || (!data[key] && data[key] !== false))
        delete data[key];
    return data;
  };

  const postForm = () => {
    // Association du groupe à l'utilisateur
    let createdBy = "/api/users/" + props.auth.userConnected.id;

    // Création d'un object qui va contenir toutes les clés du formulaire soumis
    var data = new Object();
    var dataMembers = new Object();
    data.description = DOMPurify.sanitize(data.description);
    data.createdBy = createdBy;
    data = { ...formData };
    data = fillImage(data);
    data = fillAssociations(data);
    data = fillCategory(data);
    data = cleanEmptyKeys(data);
    data = {
      ...data,
      groupMembers: JSON.stringify(
        members.map((member) => `/api/users/${member.id}`)
      ),
    };
    sendRequest(data);
    sendMembers(dataMembers);
  };

  // variables du formulaire
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
    trigger,
    watch,
    // setValue,
  } = useForm({ defaultValues });

  /**
   * Fonction permettant d'assigner les données du formulaire
   * à une variable
   * @param {Object} data données du formulaire
   */
  const onSubmit = async (data) => {
    let check = await trigger();
    if (check) setFormData(data);
  };

  /**
   * Fonction permettant de filtrer les membres en fonction des paramètres
   * sélectionnés
   * @param {{id: Number}} composante - composante sélectionnée
   * @param {{id: Number}}  speciality- spécialité sélectionnée
   * @param {{id: Number}}  year - année de promotion sélectionnée
   * @param {{id: Number}}  domain - domaine sélectionné
   * @returns {{composante: {id: {number}}, speciality: {id: {number}}, year:{id: {number}}, domain: {id: {number}}}} - tableau des membres filtrés
   */
  const makeFilteredMembersURL = (composante, speciality, year, domain) => {
    let url = process.env.REACT_APP_BASE_URL_API;
    url += "/users";
    url = new URL(url);
    if (composante && composante.id)
      url.searchParams.append("composante", composante.id);
    if (speciality && speciality.id)
      url.searchParams.append("speciality", speciality.id);
    if (year) url.searchParams.append("promotionYear", year);
    if (domain && domain.id) url.searchParams.append("domain", domain.id);
    setFilteredMembersURL(url);
  };

  // UseEffect pour filtrer les membres en fonction des champs suivants :
  // composante, spécialité, année de promotion, domaine
  useEffect(() => {
    const composante = getValues("educationComposante");
    const speciality = getValues("educationSpeciality");
    const year = getValues("graduationYear");
    const domain = getValues("educationDomain");
    if (composante?.id || speciality?.id || year || domain?.id)
      makeFilteredMembersURL(composante, speciality, year, domain);
    else setMembers([]);
  }, [
    watch("educationDomain"),
    watch("educationComposante"),
    watch("educationSpeciality"),
    watch("graduationYear"),
  ]);

  /**
   * Affichage d'une erreur si nécessaire dans le formulaire
   * @param {String} name nom du champ
   * @returns {JSX.Element}
   */
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  /**
   * Fonction permettant de combiner le code de la composante et son nom, si ce n'est pas déjà fait
   * puis de les trier par ordre alphabétique
   * @param {Object[]} composantes - liste des composantes
   * @param {string} composantes[].label - nom de la composante
   * @param {string} composantes[].code_composante - code de la composante
   * @returns {Array<{label: String, code_composante: String, displayLabel: String}>} - liste des composantes formatées et triées
   */
  const formatComposantes = (composantes) => {
    composantes
      .map((composante) => {
        if (!composante.label.match("\\d+[':']"))
          composante.displayLabel =
            composante["code_composante"] + ": " + composante.label;
        else composante.displayLabel = composante.label;
        return composante;
      })
      .sort((a, b) => a.displayLabel.localeCompare(b.displayLabel));
    return composantes;
  };

  return (
    <div>
      <Toast ref={uploadToast} />
      <Toast ref={cancelToast} />
      <div className="groupe_container">
        <div className="groupe_container__title">
          {props.auth.isAdmin ? (
            <h1 className="h1_trait_dessus">Créer un groupe</h1>
          ) : (
            <h1 className="h1_trait_dessus">Proposer un groupe</h1>
          )}

          <div className="groupe_container__title__filtres gestion">
            <BtnBlanc
              btnTexte="Gérer mes groupes"
              btnAction={() => props.setCreation(!props.creation)}
            >
              <FaCog />
            </BtnBlanc>
          </div>
        </div>

        {/* <p> Sous-titres à définir</p> */}
        <div className="creation_groupe_container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="question_columns large">
              <div className="question">
                <h2
                  htmlFor="label"
                  className={classNames({ "p-error": errors.label })}
                >
                  Titre du groupe *
                </h2>
                <Controller
                  name="label"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Veuillez entrer un titre",
                    },
                    maxLength: {
                      message:
                        "Le titre ne peut avoir que 50 caractères maximum",
                      value: 50,
                    },
                    validate: async (value) => {
                      let exists = await fetchGet(`/groups?label=${value}`);

                      return exists &&
                        exists.length > 0 &&
                        value === exists?.at(0)?.label
                        ? "Ce titre de groupe existe déjà"
                        : true;
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      value={field.value}
                      id={field.name}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        trigger("label");
                      }}
                      placeholder="Groupe de ..."
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe")
                      }
                    />
                  )}
                />
                {getFormErrorMessage("label")}
              </div>
              <div className="question">
                <h2
                  htmlFor="groupCategory"
                  className={classNames({ "p-error": errors.groupCategory })}
                >
                  Catégorie du groupe
                </h2>
                {categories.length > 0 ? (
                  <Controller
                    name="groupCategory"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        optionLabel="label"
                        editable
                        id={field.name}
                        showClear
                        value={field.value}
                        options={categories}
                        placeholder="Sport, international, culture..."
                        onChange={(e) => field.onChange(e.value)}
                        className={
                          (classNames({
                            "p-invalid": fieldState.invalid,
                          }),
                          "input_groupe")
                        }
                      />
                    )}
                  />
                ) : (
                  <Loader />
                )}
                {getFormErrorMessage("groupCategory")}
              </div>
            </div>

            <div className="question column">
              <h2>Associer le groupe à :</h2>
            </div>
            <div className="question_columns">
              <div className="question">
                <label
                  htmlFor="educationComposante"
                  className={classNames({
                    "p-error": errors.educationComposante,
                  })}
                >
                  Une composante
                </label>
                <Controller
                  name="educationComposante"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      optionLabel="displayLabel"
                      id={field.name}
                      value={field.value}
                      filter
                      showClear
                      options={formatComposantes(composanteData)}
                      placeholder="Composante"
                      onChange={(e) => field.onChange(e.value)}
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe groupes-dropdown")
                      }
                    />
                  )}
                />
              </div>
              <div className="question">
                <label
                  htmlFor="graduationYear"
                  className={classNames({
                    "p-error": errors.graduationYear,
                  })}
                >
                  Une année de promo
                </label>
                <Controller
                  name="graduationYear"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Calendar
                      id={field.name}
                      {...field}
                      dateFormat="yy"
                      placeholder="Année de promotion"
                      view="year"
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_group")
                      }
                      style={{ width: "100%" }}
                    />
                  )}
                />
                {getFormErrorMessage("graduationYear")}
              </div>
              <div className="question">
                <label
                  htmlFor="educationDomain"
                  className={classNames({
                    "p-error": errors.educationDomain,
                  })}
                >
                  Un domaine de formation
                </label>
                <Controller
                  name="educationDomain"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      optionLabel="label"
                      id={field.name}
                      showClear
                      filter
                      value={field.value}
                      options={formationData}
                      placeholder="Domaine de formation"
                      onChange={(e) => field.onChange(e.value)}
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe groupes-dropdown")
                      }
                    />
                  )}
                />
              </div>
              <div className="question">
                <label
                  htmlFor="educationSpeciality"
                  className={classNames({
                    "p-error": errors.educationSpeciality,
                  })}
                >
                  Une spécialité
                </label>
                <Controller
                  name="educationSpeciality"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      optionLabel="customLabel"
                      id={field.name}
                      value={field.value}
                      showClear
                      filter
                      options={specialites}
                      placeholder="Spécialité"
                      onChange={(e) => field.onChange(e.value)}
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe groupes-dropdown")
                      }
                    />
                  )}
                />
              </div>
            </div>
            <div className="question search">
              <h2>Ajouter des personnes</h2>

              <div className="multiselect-demo">
                <div className="multiselect-demo_list">
                  {members.map((member, index) => (
                    <span key={index} className="member_fullname">
                      <span className="member_firstname">
                        {member.firstname}
                      </span>
                      <span className="member_surname">{member.surname}</span>
                      <CgClose
                        onClick={() => {
                          setMembers(
                            members.filter((item) => item.id != member.id)
                          );
                        }}
                      ></CgClose>
                    </span>
                  ))}
                </div>
                <SearchPeople
                  userList={members}
                  setUserList={setMembers}
                ></SearchPeople>
              </div>
            </div>
            <ChargementImage
              image={image}
              setImage={setImage}
              imageFile={imageFile}
              setImageFile={setImageFile}
              setImageId={setImageId}
              uploadToast={uploadToast}
              cancelToast={cancelToast}
              phototheque={phototheque}
              setPhototheque={setPhototheque}
              path="groups"
              long
            />
            <div className="description">
              <h2
                htmlFor="description"
                className={classNames({ "p-error": errors.description })}
              >
                Description du groupe *
              </h2>
              <Controller
                name="description"
                control={control}
                rules={{
                  required: {
                    message: "La description est requise",
                    value: true,
                  },
                }}
                render={({ field }) => (
                  <ReactQuill
                    id={field.name}
                    {...field}
                    theme="snow"
                    modules={QuillOptions.modules}
                    formats={QuillOptions.formats}
                    rows={5}
                  />
                )}
              />
              {getFormErrorMessage("description")}
            </div>
            <div className="groupe_prive">
              <div className="question checkbox">
                <Controller
                  name="public"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Checkbox
                      id={field.name}
                      checked={!field.value}
                      onChange={(e) => field.onChange(!e.checked)}
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe")
                      }
                    />
                  )}
                />
                <label
                  htmlFor="public"
                  className={classNames({ "p-error": errors.public })}
                >
                  <i className="pi pi-lock"></i> Groupe privé
                </label>
                {getFormErrorMessage("public")}
              </div>
              <div className="question checkbox">
                <Controller
                  name="public"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Checkbox
                      id={field.name}
                      checked={field.value}
                      onChange={(e) => field.onChange(e.checked)}
                      className={
                        (classNames({
                          "p-invalid": fieldState.invalid,
                        }),
                        "input_groupe")
                      }
                    />
                  )}
                />
                <label
                  htmlFor="public"
                  className={classNames({ "p-error": errors.public })}
                >
                  <i className="pi pi-lock-open"></i> Groupe public
                </label>
                {getFormErrorMessage("public")}
              </div>
            </div>
            {props.auth.userConnected.userRoles.some(
              (role) =>
                role.roleName == "ROLE_ADMIN_DU_PORTAIL" ||
                role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
            ) && (
              <div className="groupe_prive">
                <div className="question checkbox">
                  <Controller
                    name="institutional"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Checkbox
                        id={field.name}
                        checked={field.value}
                        onChange={(e) => field.onChange(e.checked)}
                        className={
                          (classNames({
                            "p-invalid": fieldState.invalid,
                          }),
                          "input_groupe")
                        }
                      />
                    )}
                  />
                  <label
                    htmlFor="institutional"
                    className={classNames({ "p-error": errors.institutional })}
                  >
                    <i className="pi pi-lock"></i> Ce groupe est un groupe
                    institutionnel
                  </label>
                  {getFormErrorMessage("institutional")}
                </div>
              </div>
            )}

            <div className="question bouton">
              {submitted && (
                <Modal
                  visible={submitted}
                  setVisible={setSubmitted}
                  className={"modal modal_groupe-creation"}
                  header={
                    props.auth.isAdmin
                      ? "Votre groupe a bien été publié"
                      : "Votre groupe a bien été soumis"
                  }
                >
                  <i className="pi pi-send"></i>
                  <div className="description">
                    <p>
                      <center>
                        {props.auth.isAdmin
                          ? "Votre groupe a bien été publié"
                          : "Votre demande de création de groupe a été enregistrée et envoyée à l'équipe Réseau Pro;"}
                      </center>
                    </p>
                    {!props.auth.isAdmin ? (
                      <>
                        <p>
                          <center>Il sera disponible après validation.</center>
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          <center>
                            Votre groupe a bien été publié sur Réseau Pro.
                          </center>
                        </p>
                        <p>
                          <center>
                            Il est désormais visible dans la page des groupes
                          </center>
                        </p>
                      </>
                    )}
                  </div>
                  <div className="modals-buttons">
                    <BtnBleu
                      btnTexte="Déposer un nouveau groupe"
                      btnAction={(e) => {
                        e.preventDefault();
                        setSubmitted(false);
                      }}
                    />
                    <BtnBlanc
                      btnTexte="Retour sur mes groupes"
                      btnAction={(e) => {
                        e.preventDefault();
                        props.setCreation(!props.creation);
                        updateState();
                        setSubmitted(false);
                      }}
                    />
                  </div>
                </Modal>
              )}
              {cancelToast.current && (
                <button
                  type="button"
                  className="btn-bleu"
                  onClick={async () =>
                    (await !trigger())
                      ? cancelToast.current.show({
                          severity: "error",
                          summary: "Validation",
                          detail: "Le formulaire n'est pas valide",
                          sticky: true,
                        })
                      : onSubmit(getValues())
                  }
                >
                  {props.auth.isAdmin
                    ? "Créer le groupe"
                    : "Envoyer la demande de création de groupe"}
                </button>
              )}
            </div>
          </form>
          {visibleModalCharte && (
            <ModalCharteGroupes
              visibleModalCharte={visibleModalCharte}
              setvisibleModalCharte={setvisibleModalCharte}
              btnAccept={postForm}
              btnRefuse={() => {
                cancelToast.current.show({
                  severity: "error",
                  summary: "Charte",
                  detail: "Le groupe ne peut pas être créé",
                  sticky: true,
                });
              }}
            ></ModalCharteGroupes>
          )}
        </div>
      </div>
    </div>
  );
};
GroupeCreation.propTypes = {
  name: PropTypes.string,
  chapeau: PropTypes.string,
  bouton: PropTypes.string,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  items: PropTypes.object,
  handleMenu: PropTypes.func,
  creation: PropTypes.bool,
  setCreation: PropTypes.func,
  auth: PropTypes.object,
  groups: PropTypes.object,
  handleGroups: PropTypes.func,
  users: PropTypes.object,
  secondaryTables: PropTypes.object,
  states: PropTypes.object,
};
const mapStateToProps = (state) => ({
  items: state.items,
  auth: state.auth,
  groups: state.groups,
  users: state.users,
  states: state.states,
  secondaryTables: state.secondaryTables,
});
const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleGroups: (value) => {
    dispatch(updateGroups(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupeCreation);
